export const userStatus = (statusTxt) => {
  let status = "danger";
  if (statusTxt.toUpperCase().indexOf("INACTIVE") > -1) {
    status = "warning";
  } else if (statusTxt.toUpperCase().indexOf("ACTIVE") > -1) {
    status = "success";
  }
  return status
}